import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartguy/src/app/(Guest)/videos/[slug]/components/VideoPage.jsx");
